import React from 'react';
import { useSelector } from 'react-redux';
import DayPageShell from './DayPageShell';
import WordleGame from '../WordleGame';
import { s3PublicUrl } from '../../../utils/s3PublicUrl';

export default function Day1({ onStageComplete }) {
  const themeData = useSelector((state) => state.theme.data);
  const stage1 = themeData?.stages_data?.stage_1;
  const q0 = stage1?.questions?.[0];
  const rawWord = String(q0?.word ?? '').trim();
  const answerWord = rawWord.replace(/[^a-zA-Z]/g, '').toUpperCase();

  const badgeUrl = s3PublicUrl(stage1?.badge);
  const pointsIconUrl = s3PublicUrl(themeData?.points_icon);
  const correctPoints = themeData?.correct_points ?? 0;
  const dayBonusPoints = themeData?.bonus_points ?? 0;

  const isConfigured =
    stage1 &&
    stage1.type === 'wordle' &&
    answerWord.length === 5;

  return (
    <div
      style={{
        // Force Day 1 Wordle colors (no theme-driven dynamic colors)
        '--box-bg-color': '#ffffff',
        '--box-text-color': '#000000',
        '--text-color': '#000000',
        '--option-color': '#000000',
        '--option-text-color': '#ffffff',
      }}
    >
      <DayPageShell dayNumber={1} className="main-day-view--immersive">
      {!isConfigured ? (
        <p className="main-day-subtitle">
          Word puzzle is not configured: set stage_1 type &quot;wordle&quot; and a 5-letter word in
          questions[0].word.
        </p>
      ) : (
        <WordleGame
          answerWord={answerWord}
          didYouKnow={String(q0?.did_you_know ?? '')}
          didYouKnowImage={String(stage1?.did_you_know_image ?? q0?.did_you_know_image ?? '')}
          questionImage={String(stage1?.question_image ?? q0?.question_image ?? '')}
          questionText={String(q0?.question ?? '')}
          badgeTitle={String(stage1?.title ?? stage1?.name ?? 'Day 1')}
          rules={stage1.rules}
          badgeUrl={badgeUrl}
          correctPoints={correctPoints}
          dayBonusPoints={dayBonusPoints}
          pointsIconUrl={pointsIconUrl}
          onComplete={onStageComplete}
        />
      )}
      </DayPageShell>
    </div>
  );
}
